var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("h3", { staticClass: "mt-3 mb-1" }, [
        _vm._v(
          "\n        " +
            _vm._s(_vm.$l10n.__("Recherche de documents")) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("p", { staticClass: "grey m-0" }, [
        _vm._v(
          "\n        " +
            _vm._s(
              _vm.$l10n.__(
                "Complétez un ou plusieurs champs et lancez votre recherche"
              )
            ) +
            "\n    "
        )
      ]),
      _vm._v(" "),
      _c("rb-filter", {
        attrs: {
          "transaction-id": _vm.transactionId,
          "transaction-type": _vm.transactionType,
          "transaction-date": _vm.DateObjTransaction
        }
      }),
      _vm._v(" "),
      _c("preloader", { attrs: { display: _vm.sharedState.loadingDocs } }),
      _vm._v(" "),
      !_vm.sharedState.loadingDocs
        ? _c("rb-document-listing", { staticClass: "mt-1" })
        : _vm._e(),
      _vm._v(" "),
      _vm.sharedState.reconciled.length > 1
        ? _c(
            "fixed-footer",
            [
              _c(
                "el-row",
                [
                  _c("el-col", { attrs: { span: 8 } }, [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm.$l10n.__("Rapprochement multiple : ")) +
                        "\n                "
                    ),
                    _c("span", { staticClass: "grey fs-4" }, [
                      _vm._v(
                        "\n                    (" +
                          _vm._s(
                            _vm.$l10n.__(
                              "%d actions",
                              _vm.sharedState.reconciled.length
                            )
                          ) +
                          ")\n                "
                      )
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 6 } },
                    [
                      _c("rb-footer-amount", {
                        attrs: { "transaction-type": _vm.transactionType }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { attrs: { span: 8, offset: 2 } },
                    [
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__(
                            "bankreconciliation.DocumentForm.see_selection_and_reconcile"
                          ),
                          type: "tertiary"
                        },
                        on: {
                          click: function($event) {
                            _vm.dialogVisible = true
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _c(
            "fixed-footer",
            [
              _c(
                "el-row",
                { staticClass: "container-big m-auto" },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 8, offset: 8 } },
                    [
                      _c("rb-footer-amount", {
                        attrs: { "transaction-type": _vm.transactionType }
                      })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "el-col",
                    { staticClass: "aright", attrs: { span: 8 } },
                    [
                      _c("CompassButton", {
                        staticClass: "mr-2",
                        attrs: {
                          label: _vm.$t.__(
                            "common.actions.save_and_back_to_list"
                          ),
                          type: "tertiary",
                          loading: _vm.loading
                        },
                        on: {
                          click: function($event) {
                            return _vm.recordReconciliations("backward")
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("CompassButton", {
                        attrs: {
                          label: _vm.$t.__("common.actions.save"),
                          type: "primary",
                          loading: _vm.loading
                        },
                        on: {
                          click: function($event) {
                            return _vm.recordReconciliations("reload")
                          }
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
      _vm._v(" "),
      _c(
        "CompassDialog",
        {
          staticClass: "document-form",
          attrs: { visible: _vm.dialogVisible, size: "large" },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [
          _c("template", { slot: "header" }, [
            _c("div", { staticClass: "dialog__header" }, [
              _c("div", { staticClass: "dialog__header--container" }, [
                _c("span", { staticClass: "dialog__header--title" }, [
                  _vm._v(
                    "\n                        " +
                      _vm._s(_vm.$l10n.__("Rapprochement multiple")) +
                      "\n                    "
                  )
                ]),
                _vm._v(" "),
                _c("span", { staticClass: "gray-60" }, [
                  _vm._v(
                    "\n                        (" +
                      _vm._s(
                        _vm.$l10n.__(
                          "%d actions",
                          _vm.sharedState.reconciled.length
                        )
                      ) +
                      ")\n                    "
                  )
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "dialog__header--close" },
                [
                  _c("CompassIconButton", {
                    attrs: { icon: "close" },
                    on: {
                      click: function($event) {
                        _vm.dialogVisible = false
                      }
                    }
                  })
                ],
                1
              )
            ])
          ]),
          _vm._v(" "),
          _c("template", { slot: "default" }, [
            _c(
              "div",
              { staticClass: "dialog__default" },
              [
                _c(
                  "el-table",
                  {
                    staticStyle: { width: "100%" },
                    attrs: { data: _vm.sharedState.reconciled }
                  },
                  [
                    _c("el-table-column", {
                      attrs: {
                        prop: "document.thirdname",
                        label: _vm.$t.__("common.labels.name")
                      }
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t.__("common.labels.document_number")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _c(
                                "a",
                                {
                                  attrs: {
                                    href: scope.row.document.link,
                                    target: "_blank"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n                                " +
                                      _vm._s(scope.row.document.ident) +
                                      "\n                            "
                                  )
                                ]
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t.__("common.labels.amount_including_tax")
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("numberformatCurrency")(
                                      scope.row.document.totalAmount
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          }
                        }
                      ])
                    }),
                    _vm._v(" "),
                    _c("el-table-column", {
                      attrs: {
                        label: _vm.$t.__(
                          "bankreconciliation.DocumentForm.payment"
                        )
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "default",
                          fn: function(scope) {
                            return [
                              _vm._v(
                                "\n                            " +
                                  _vm._s(
                                    _vm._f("numberformatCurrency")(
                                      scope.row.amount
                                    )
                                  ) +
                                  "\n                        "
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _vm._v(" "),
                _c("p", { staticClass: "aright" }, [
                  _vm._v(
                    "\n                    " +
                      _vm._s(_vm.$l10n.__("Total rapproché : ")) +
                      "\n                    "
                  ),
                  _c("strong", [
                    _vm._v(
                      _vm._s(
                        _vm._f("numberformatCurrency")(_vm.totalReconciled)
                      )
                    )
                  ])
                ])
              ],
              1
            )
          ]),
          _vm._v(" "),
          _c("template", { slot: "footer" }, [
            _c(
              "div",
              { staticClass: "dialog__footer" },
              [
                _c("CompassButton", {
                  attrs: {
                    label: _vm.$t.__("common.actions.save_and_back_to_list"),
                    type: "tertiary",
                    loading: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.recordReconciliations("backward")
                    }
                  }
                }),
                _vm._v(" "),
                _c("CompassButton", {
                  staticClass: "ml-3",
                  attrs: {
                    label: _vm.$t.__("common.actions.save"),
                    type: "primary",
                    loading: _vm.loading
                  },
                  on: {
                    click: function($event) {
                      return _vm.recordReconciliations("reload")
                    }
                  }
                })
              ],
              1
            )
          ])
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }